import { Routes } from '@angular/router';
import { InvoicesComponent } from '../../pages/invoices/invoices.component';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { RoleAccountGuard } from '../../guards/role-account.guard';

export const invoicesRoutes: Routes = [
  {
    path: 'invoices',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.invoices', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/add',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.drafts', role: ['Admin', 'Supervisor'], account_type: ['broker'] },
  },
  {
    path: 'invoices/drafts',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.drafts', role: ['Admin', 'Supervisor'], account_type: ['broker'] },
  },
  {
    path: 'invoices/drafts/:reference',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.drafts', role: ['Admin', 'Supervisor'], account_type: ['broker'] },
  },
  {
    path: 'invoices/pending',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.pending', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/pending/:reference',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.pending', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/paid',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.paid', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/paid/:reference',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.paid', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/cancelled',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.cancelled', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/cancelled/:reference',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.cancelled', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'invoices/all',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.all', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },




  {
    path: 'invoices/all/:reference',
    component: InvoicesComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.all', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
];
export function getFilteredInvoicesRoutes(accountType: string, role: string): Routes {
  return invoicesRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
